module.exports = __webpack_public_path__ + "media/images/banner/kickstarter/food_book_banner_h3-7ddd434f079a1c00b83f4e8b1c94b579.jpeg";